import { defineMessages } from "react-intl"

export default defineMessages({
  licenseAgreementSwitchLabel: {
    id: "admin.licenseAgreement.switchLabel",
    defaultMessage: "Require license agreement to use the portal"
  },
  licenseAgreementEnabledSwitchSubtitle: {
    id: "admin.licenseAgreement.enabled.switchSubtitle",
    defaultMessage:
      "Users will need to read and agree to the license in order to use the portal."
  },
  licenseAgreementDisabledSwitchSubtitle: {
    id: "admin.licenseAgreement.disabled.switchSubtitle",
    defaultMessage:
      "Users currently do not need to read and agree to the license in order to use the portal."
  },
  licenseLabel: {
    id: "admin.licenseAgreement.licenseLabel",
    defaultMessage: "End-user license agreement ({locale})"
  },
  localeDescription: {
    id: "admin.licenseAgreement.localeDescription",
    defaultMessage:
      "The user will be shown the license that corresponds to their locale."
  },
  saveChanges: {
    id: "admin.licenseAgreement.saveChanges",
    defaultMessage: "Save changes"
  },
  showPreview: {
    id: "admin.licenseAgreement.showPreview",
    defaultMessage: "Show preview"
  },
  licenseSaveSuccess: {
    id: "admin.licenseAgreement.configuration.save.success",
    defaultMessage: "Successfully saved license agreement configuration"
  },
  licenseDisableSuccess: {
    id: "admin.licenseAgreement.configuration.disable.success",
    defaultMessage: "Successfully disabled license agreement requirement"
  }
})
